<template>
  <div class="container" ref="container">
    <div class="content">
      <h4>1. Stadssalg</h4>

      Stadssalg AS (Stadssalg) er et norsk selskap registrert i
      Brønnøysundsregistrene med organisasjonsnummer: NO 991 743 634 MVA.
      Stadssalg er et avviklingsselskap som gjennom et internettbasert
      auksjonssystem (Auksjonssystemet) selger biler, båter, maskiner og andre
      objekter på vegne av banker, finansieringsselskaper, inkassobyråer,
      bostyrere, namsmyndighetene og andre. Disse omtales i det følgende som
      våre oppdragsgivere. Når du bruker Auksjonssystemet samler vi inn, bruker
      og behandler personopplysninger om deg. Dersom du er eier av et objekt som
      skal selges gjennom Auksjonssystemet vil vi motta visse opplysninger om
      deg fra våre oppdragsgivere. I denne personvernerklæringen forklarer vi
      hvordan vi behandler personopplysningene, og hvilket formål og rettslig
      grunnlag denne behandlingen har. Vi forklarer også når og hvorfor
      personopplysninger utleveres til en tredjepart. Vi informerer deg også om
      hvilke rettighetene du har i forbindelse med behandling og overføring av
      dine personopplysninger. Stadssalg ved administrerende direktør er
      behandlingsansvarlig for dine personopplysninger. Det betyr at Stadssalg
      er ansvarlig for å definere formålene med behandlingen av
      personopplysninger og dessuten for å overholde personvernlovgivningen. Du
      finner vår adresse og kontaktinformasjon nederst i denne
      personvernerklæringen

      <h4>2. Stadssalgs behandling av personopplysninger</h4>

      <h5>2.1 Brukerkonto</h5>

      For å kunne legge inn bud i Auksjonssystemet må du opprette en brukerkonto
      hos Stadssalg. For å opprette brukerkonto må du registrere deg med navn,
      telefonnummer, e-postadresse, og adresse. Når du legger inn et bud i våre
      systemer vil dette bli registrert og lagret knyttet til
      personopplysningene om deg. Disse opplysningene benyttes til å dokumentere
      budprosessen, slik at vår oppdragsgiver kan kontrollere at den er
      gjennomført på korrekt måte. Opplysninger om bud du har inngitt vil være
      tilgjengelig for deg via din brukerkonto. Du kan lese om hvor lenge
      opplysningene oppbevares nedenfor i punkt 5

      <h5>2.2 Kjøp gjennom Auksjonssystemet</h5>

      Dersom du får tilslag på et bud du har lagt inn i Auksjonssystemet, og
      budet blir godtatt av oppdragsgiver/selger i henhold til de alminnelige
      brukervillkårene for Auksjonssystemet, vil dette bli registrert på din
      brukerkonto. Det vil da også bli utferdiget en kontrakt hvor vilkårene for
      kjøpet fremkommer. Kontrakten vil inneholde de opplysninger, herunder
      personopplysninger, som er nødvendig for å gjennomføre avtalen. Kontrakten
      vil bli oversendt til vår oppdragsgiver, og dessuten lagret hos Stadssalg.
      I tillegg til de opplysninger som er nødvendige for å oppfylle kontrakten,
      vil du måtte oppgi de personopplysninger Stadssalg er forpliktet til å
      innhente for å oppfylle kravene i hvitvaskingsloven. Det rettslige
      grunnlaget for behandlingen av personopplysninger som beskrevet i dette
      punktet er din godkjenning av våre brukervilkår når du registrer deg som
      bruker av Auksjonssystemet. Vi behandler dessuten disse opplysningene på
      det grunnlaget at det er nødvendig for oss for å kunne gjennomføre avtaler
      som er inngått ved bruk av Auksjonssystemet hvor du er en part. Du kan
      lese om hvor lenge opplysningene oppbevares nedenfor i punkt 5.

      <h5>2.3 Tilbud om finansiering/forsikring</h5>

      Stadssalg vil i forbindelse med bruk av Auksjonssystemet tilby
      finansiering og forsikring på vegne av tredjeparter. Du vil da bli bedt om
      å oppgi de opplysninger som er nødvendig for at tilbyderen skal kunne
      behandle din søknad. Opplysninger du oppgis i denne forbindelse vil bli
      oversendt til den tredjeparten du søker om lån/forsikring hos.
      Opplysningene vil ikke bli lagret hos Stadssalg. Det rettslige grunnlaget
      for behandling av personopplysninger som beskrevet i dette punktet er ditt
      samtykke.

      <h5>2.4 Markedsføring</h5>
      Stadssalg benytter ikke personopplysninger om deg til markedsføring.

      <h5>2.5 Opplysninger om debitorer</h5>

      Dersom du er eier av et objekt som blir solgt gjennom Auksjonssystemet,
      vil Stadssalg få overført visse personopplysninger om deg fra våre
      oppdragsgivere. Dette er foruten identifikasjonsopplysninger, opplysninger
      om gjeld/heftelser som skal søkes dekket gjennom salget, og hva som er
      gjort av saksbehandling i saken. Disse opplysningene vil utelukkende
      benyttes til å gjennomføre oppdraget fra vår oppdragsgiver. Opplysningene
      vil ikke bli delt med andre enn oppdragsgiver for det aktuelle oppdraget.
      Det rettslige grunnlaget for vår behandling av personopplysninger som
      beskrevet i dette punktet er at det er nødvendig for å ivareta vår
      berettigede interesse i å utføre tjenester for våre oppdragsgivere. Vi vil
      også kunne behandle denne type opplysninger for å gjøre gjeldende eller
      forsvare oss mot rettskrav.

      <h4>3. Utlevering av personopplysninger til tredjeparter</h4>

      Stadssalg selger ikke personopplysninger for markedsføringsformål til
      andre. Stadssalg kan komme til å utlevere personopplysninger om deg i
      følgende tilfeller:

      <ul>
        <li>
          Til våre oppdragsgivere (Selgere i Auksjonssystemet) når det er
          nødvendig for å dokumenter et salg, eller at budgivningsprosessen har
          vært gjennomført på korrekt måte.
        </li>
        <li>
          Dersom det er nødvendig for å oppfylle en avtale du har inngått
          gjennom Auksjonssystemet, for eksempel til Biltilsynet ved
          omregistrering av kjøretøy.
        </li>
        <li>
          Når det er nødvendig for å gjøre gjeldende eller forsvare seg mot et
          rettskrav (herunder å håndheve gjeldende brukervilkår); eller
        </li>
        <li>
          Til offentlige myndigheter når det er påkrevd i henhold til lov,
          rettsavgjørelse eller rettskraftig vedtak fra myndighetene.
        </li>
      </ul>

      <h4>4. Informasjonskapsler og lignende teknologi</h4>

      Når du besøker nettstedet vårt, samler vi inn visse opplysninger ved hjelp
      av informasjonskapsler. Informasjonskapsler er små tekstfiler som lagres
      på enheten din når du besøker et nettsted. Når du besøker et nettsted for
      første gang, sendes det en informasjonskapselfil til enheten din. Denne
      filen identifiserer nettleseren din. Ved å bruke informasjonskapsler
      hjelper du Stadssalg med å forbedre funksjonaliteten på nettstedet vårt.
      De er viktige for å redusere nedlastingstiden og forbedre
      brukeropplevelsen. Informasjonskapselen samler inn informasjon om hvordan
      besøkende bruker nettstedene våre, og gir oss dermed nyttig informasjon om
      hvordan vi kan levere en bedre kundeopplevelse og forbedre tjenestene
      våre. Vi bruker også informasjonskapsler for autentiseringsformål, slik at
      du ikke trenger å identifisere deg hver gang du besøker nettstedet vårt.
      Disse informasjonskapslene er strengt nødvendige for at tjenesten skal
      fungere tilfredsstillende. Ved å justere de tekniske innstillingene i
      nettleseren kan du hindre at informasjonskapsler blir lagret og er
      tilgjengelige på enheten din. Men merk at hvis du deaktiverer
      informasjonskapsler, kan du kanskje ikke bruke tjenestene på nettstedet
      vårt. Stadssalg benytter Google Analytics. Det hjelper oss med å forstå
      hvordan besøkende bruker tjenestene våre. Dette verktøyet kan bruke et
      sett med informasjonskapsler for å samle informasjon og rapportere
      statistikk om bruk av nettsteder, uten at enkelte besøkende identifiseres
      for Google. I tillegg til å rapportere bruksstatistikk for nettsteder kan
      Google Analytics også brukes sammen med noen av informasjonskapslene for
      annonsering som er beskrevet ovenfor, for å vise mer relevante annonser,
      samt for å måle interaksjon med annonsene vi viser. Her kan du lese mer om
      <strong
        ><a
          target="_blank"
          href="https://developers.google.com/analytics/resources/concepts/gaConceptsCookies?hl=no"
          >Analytics-informasjonskapsler</a
        ></strong
      >

      <h4>5. Dine rettigheter</h4>

      Du har rett til innsyn, korrigering, begrensning og sletting av
      personopplysninger som vi har registrert om deg. Du har dessuten rett til
      å motta en kopi av personopplysningene i et strukturert, maskinlesbart
      format. Henvendelser om behandling av personopplysninger og anmodning om
      innsyn rettes til kontaktpunktet angitt i punkt 10 nedenfor.

      <h5><i>5.1 Sletting av personopplysninger</i></h5>
      Du kan når som helst ta kontakt med oss for å be om at vi sletter de
      personopplysninger vi har registrert om deg. Du kan ikke kreve at vi
      sletter personopplysninger som vi enten er lovpålagt å oppbevare, eller
      som vi har en berettiget interesse i å oppbevare for å kunne gjøre
      gjeldende eller forsvare oss mot rettskrav. Tilbakekall av samtykke vil
      likevel ikke påvirke behandlingen vi har foretatt basert på samtykket før
      det ble tilbakekalt. Personopplysninger om vil uansett bli slettet når vi
      ikke lengre har noen berettiget interesse i å oppbevare dem. Dette vil
      senest skje etter 10 år. Du har også rett til å motsette deg visse typer
      behandling Hvis vi behandler opplysninger fordi vi har en berettiget
      interesse av å gjøre det (som forklart ovenfor), har du også rett til å
      motsette deg dette, men denne rettigheten kan være begrenset i visse
      situasjoner – for eksempel hvis vi kan vise at vi er lovpålagt å behandle
      opplysninger eller hvis vi har en berettiget interesse i å behandle
      opplysningene for å gjøre gjeldende eller forsvare oss mot rettskrav. Hvis
      vi ber om personopplysninger for å overholde lov- eller kontraktsfestede
      forpliktelser, er det obligatorisk å gi slike opplysninger. Hvis slike
      opplysninger ikke gis, vil vi ikke kunne administrere kontraktsforholdet
      vårt eller oppfylle forpliktelsene vi skal. I alle andre tilfeller er det
      valgfritt å gi anmodede personopplysninger.

      <h4>6. Overføring av personopplysninger til andre land</h4>
      Overføring av personopplysninger til et tredjeland utenfor EØS skjer
      normalt ikke. Dersom det unntaksvis skulle bli aktuelt vil dette kun skje
      hvis det gis nødvendige garantier, f.eks. ved at det foreligger bindende
      virksomhetsregler (BCR), at EUs standardavtalevilkår inngås, eller hvis
      mottakeren er sertifisert etter EU-US Privacy Shield. Hvis du har spørsmål
      til dette, kan du kontakte oss som angitt nedenfor.

      <h4>7. Tredjeparters personvernerklæringer</h4>
      Denne personvernerklæringen gjelder bare Stadssalg egen innsamling, bruk
      og utlevering av personopplysninger. Andre parter vi samarbeider med har
      egne personvernerklæringer og egen praksis. Vi samarbeider bare med
      tredjeparter som også har høye standarder for personvernet, men har
      likevel ikke noe ansvar for personvernpraksisen hos andre tredjeparter.

      <h4>8. Endringer i denne erklæringen</h4>
      Stadssalg kan foreta endringer i denne personvernerklæringen. Informasjon
      om denne vil da bli gjort tilgjengelig for deg første gang du logger deg
      på våre tjenester etter at endringen er gjennomført. Dersom du ikke godtar
      endringene kan du slutte og bruke tjenesten vår og eventuelt slette
      kontoen din som beskrevet i punkt 5.

      <h4>9. Verneting og gjeldende lovgivning</h4>
      Denne personvernerklæringen skal tolkes i samsvar med norsk lovgivning og
      være underlagt norske domstolers kompetanse.

      <h4>10. Kontaktinformasjon</h4>
      Dersom du har spørsmål eller kommentarer til denne personvernerklæringen
      eller vår personvernpraksis kan du nå oss ved å sende en e-post til
      mottak@stadssalg.no, eller ved å sende vanlig post til:
      <strong>Stadssalg AS, Postboks 395, 8001 Bodø</strong>. Dersom du er
      misfornøyd med måten vi behandler personopplysningene dine på, eller har
      innvendinger mot vår personvernpraksis kan du dessuten klage til
      Datatilsynet som er personvernmyndigheten i Norge.
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  margin-top: 2em !important;
}
</style>
